export const cols = [{
	prop: 'cusname',
	label: '客户名称',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'beginmoney',
	label: '期初余额',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'endmoney',
	label: '期末余额',
	width: '',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'addmoney',
	label: '余额增加金额',
	width: '',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'submoney',
	label: '余额支出金额',
	width: '',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}]
